import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmt } from "@/lib/api";

export const SCALES = [
  ["mood", "Mood", ["Rough", "Low", "Okay", "Good", "Great"]],
  ["sleep", "Sleep", ["Terrible", "Poor", "Okay", "Good", "Deep"]],
  ["soreness", "Soreness", ["None", "Mild", "Moderate", "Sore", "Wrecked"]],
];

const Scale = ({ k, label, words, value, onChange }) => (
  <div className="scale" data-testid={`checkin-scale-${k}`}>
    <div className="ss" style={{ marginBottom: 4 }}>{label} · <b style={{ color: "var(--ink)" }}>{value ? words[value - 1] : "tap to rate"}</b></div>
    <div className="dots">{[1, 2, 3, 4, 5].map((n) => (
      <button key={n} type="button" className={value === n ? "on" : ""} onClick={() => onChange(n)} aria-label={`${label} ${n}`} data-testid={`checkin-${k}-${n}`}>{n}</button>))}
    </div>
  </div>
);

export const CheckInCard = ({ onChanged }) => {
  const [state, setState] = useState(null);
  const [editing, setEditing] = useState(false);
  const [f, setF] = useState({ mood: 0, sleep: 0, soreness: 0, note: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/client/me/checkin").then((r) => setState(r.data)); }, []);
  if (!state) return null;
  const c = state.checkin;
  const startEdit = () => { setF({ mood: c?.mood || 0, sleep: c?.sleep || 0, soreness: c?.soreness || 0, note: c?.note || "" }); setEditing(true); };
  const save = async (e) => {
    e.preventDefault();
    if (!f.mood || !f.sleep || !f.soreness) return toast.error("Rate all three to check in");
    setBusy(true);
    try { const r = (await api.put("/client/me/checkin", f)).data; setState(r); onChanged?.(r.checkin); setEditing(false); toast.success("Checked in — your coach will see this in tomorrow's digest"); }
    catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); }
  };
  if (c && !editing) {
    return (
      <div className="panel checkin done" data-testid="checkin-card">
        <div className="ph"><h3>Weekly check-in · Checked in ✓</h3><button className="linkbtn" onClick={startEdit} data-testid="checkin-edit-button">Edit</button></div>
        <div className="actions" style={{ gap: 14 }} data-testid="checkin-summary">
          {SCALES.map(([k, label, words]) => <span key={k} className="ss"><b style={{ color: "var(--ink)" }}>{label}</b> {c[k]}/5 · {words[c[k] - 1]}</span>)}
        </div>
        {c.note && <div className="ss" style={{ marginTop: 6 }}>“{c.note}”</div>}
        <div className="ss" style={{ marginTop: 6 }}>Updated {fmt(c.updatedAt, { weekday: "short", hour: "2-digit", minute: "2-digit" })} · next check-in opens Monday</div>
      </div>
    );
  }
  return (
    <form className="panel checkin" onSubmit={save} data-testid="checkin-card">
      <div className="ph"><h3>Weekly check-in · 20 seconds</h3>{editing && <button type="button" className="linkbtn" onClick={() => setEditing(false)} data-testid="checkin-cancel-button">Cancel</button>}</div>
      <p className="ss" style={{ marginTop: 0 }}>How's the week starting? Your coach uses this to tune your sessions.</p>
      <div className="grid3">{SCALES.map(([k, label, words]) => <Scale key={k} k={k} label={label} words={words} value={f[k]} onChange={(v) => setF({ ...f, [k]: v })} />)}</div>
      <input value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} placeholder="Anything your coach should know? (optional)" style={{ marginTop: 10 }} maxLength={240} data-testid="checkin-note-input" />
      <div className="mfoot" style={{ marginTop: 10 }}><button className="btn" disabled={busy} data-testid="checkin-submit-button">{editing ? "Update check-in" : "Check in"}</button></div>
    </form>
  );
};
